import React from 'react';
import PropTypes from 'prop-types';

import { getProductRefData } from '../../../../../utils/plansReference';
import { getLTEUpgrade } from '../../../Helpers/index';
import Product from './product';
import Tax from './tax';
import Shipping from './shipping';
import SecurityDeposit from './securityDeposit';
import RemainingBalance from './remainingBalance';

const CommonHelper = ({
  dueTodayList,
  plansReferenceData,
  dueTodayTaxes,
  shippingDetails,
  securityDepositAmt,
  dueTodayHomePhoneList,
  securityDeposit,
  pageName,
  shippingText,
  displayText,
  ltePlans,
  remainingBalanceTitle,
}) => {
  const planInfo = getProductRefData('dueTodayTax', 'dueTodayTax', plansReferenceData);
  const buyOutAmount = getLTEUpgrade() && ltePlans && ltePlans.buyOutAmount ? ltePlans.buyOutAmount : '';
  return (
    <>
      {dueTodayList && (dueTodayList.accessories || dueTodayList.deviceItem) && (
        <Product dueTodayList={dueTodayList} plansReferenceData={plansReferenceData} dueTodayHomePhoneList={dueTodayHomePhoneList} />
      )}
      {securityDepositAmt && <SecurityDeposit securityDepositAmt={securityDepositAmt} securityDepositLabel={securityDeposit} />}
      {shippingDetails && (
        <Shipping shippingDetails={shippingDetails} displayText={displayText} shippingText={shippingText} pageName={pageName} isMinicartSection />
      )}
      {getLTEUpgrade() && buyOutAmount !== '' ? <RemainingBalance ltePlans={ltePlans} remainingBalanceTitle={remainingBalanceTitle} /> : null}
      {dueTodayList && dueTodayTaxes !== null && dueTodayTaxes !== undefined && dueTodayTaxes !== '' && (
        <Tax totalDueTodayTaxAmount={dueTodayTaxes} taxText={dueTodayTaxes !== '0.0' ? planInfo?.[0]?.taxText : ''} />
      )}
    </>
  );
};

CommonHelper.propTypes = {
  dueTodayList: PropTypes.object,
  dueTodayTaxes: PropTypes.number,
  shippingDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
  securityDepositAmt: PropTypes.any,
  dueTodayHomePhoneList: PropTypes.object,
  securityDeposit: PropTypes.string,
  pageName: PropTypes.string,
  shippingText: PropTypes.string,
  displayText: PropTypes.string,
  ltePlans: PropTypes.object,
  remainingBalanceTitle: PropTypes.string,
};
export default CommonHelper;
